// extracted by mini-css-extract-plugin
module.exports = {"tableborder":"style_tableborder__2b8fe","flexBoxfull":"style_flexBoxfull__FwYKT","flexBoxhalf":"style_flexBoxhalf__jztQI"};